import { useState } from "react";

import TableHeader from "../TableHeader";

import {
  DropdownHeaderTitle,
  DropdownHeaderWrapper,
  DropdownItemWrapper,
  DropdownMenu,
  DropdownWrapper,
  Icon,
} from "./DropdownTableMenu.styled";

const DropdownTableMenu = ({
  data,
  headerData,
  renderDropdownContent,
  renderHeaderTitle,
}) => {
  const [openDropDown, setOpenDropDown] = useState([]);

  const handleOpenClick = index => {
    if (openDropDown.includes(index)) {
      setOpenDropDown(openDropDown.filter(i => i !== index));
    } else {
      setOpenDropDown([...openDropDown, index]);
    }
  };

  return (
    <DropdownMenu>
      <TableHeader>{headerData[0]}</TableHeader>

      {data?.map((item, index) => (
        <DropdownWrapper key={index}>
          <DropdownHeaderWrapper onClick={() => handleOpenClick(index)}>
            <DropdownHeaderTitle>
              {renderHeaderTitle(item, index)}
            </DropdownHeaderTitle>

            <Icon
              src="/assets/svg/arrow-down.svg"
              alt="arrow"
              isOpen={openDropDown.includes(index)}
            />
          </DropdownHeaderWrapper>

          <DropdownItemWrapper isOpen={openDropDown.includes(index)}>
            {renderDropdownContent(item)}
          </DropdownItemWrapper>
        </DropdownWrapper>
      ))}
    </DropdownMenu>
  );
};

export default DropdownTableMenu;
